// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.map-config-layout {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
}

.map-config-form {
  display: flex;
  flex-direction: column;
  flex: 0 0 280px;
}

.form-fields {
  width: 100%;
}

.map-config-preview {
  display: flex;
  flex-direction: row;
  gap: 0.5rem;
  flex: 1 1 320px;
  min-width: 320px;
  min-height: min(500px, 60vh);
}

.map-toolbox {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.map-preview-wrapper {
  position: relative;
  flex: 1 1 auto;
  height: min(500px, 60vh);
}

.map-preview-container {
  position: absolute;
  inset: 0;
}

.map-preview-placeholder {
  position: absolute;
  inset: 0;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 1rem;
  word-wrap: break-word;
  overflow-wrap: break-word;
  background-color: #d3d3d3;
  color: #333;
  font-weight: 500;
}`, "",{"version":3,"sources":["webpack://./src/app/map-configuration/map-configuration.component.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,eAAA;EACA,SAAA;AACJ;;AAEA;EACI,aAAA;EACA,sBAAA;EACA,eAAA;AACJ;;AAEA;EACI,WAAA;AACJ;;AAEA;EACI,aAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,4BAAA;AACJ;;AAEA;EACI,aAAA;EACA,sBAAA;EACA,WAAA;AACJ;;AAEA;EACI,kBAAA;EACA,cAAA;EACA,wBAAA;AACJ;;AAEA;EACI,kBAAA;EACA,QAAA;AACJ;;AAEA;EACI,kBAAA;EACA,QAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,aAAA;EACA,qBAAA;EACA,yBAAA;EACA,yBAAA;EACA,WAAA;EACA,gBAAA;AACJ","sourcesContent":[".map-config-layout {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 1rem;\n}\n\n.map-config-form {\n    display: flex;\n    flex-direction: column;\n    flex: 0 0 280px;\n}\n\n.form-fields {\n    width: 100%;\n}\n\n.map-config-preview {\n    display: flex;\n    flex-direction: row;\n    gap: 0.5rem;\n    flex: 1 1 320px;\n    min-width: 320px;\n    min-height: min(500px, 60vh);\n}\n\n.map-toolbox {\n    display: flex;\n    flex-direction: column;\n    gap: 0.5rem;\n}\n\n.map-preview-wrapper {\n    position: relative;\n    flex: 1 1 auto;\n    height: min(500px, 60vh);\n}\n\n.map-preview-container {\n    position: absolute;\n    inset: 0;\n}\n\n.map-preview-placeholder {\n    position: absolute;\n    inset: 0;\n    z-index: 1;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    text-align: center;\n    padding: 1rem;\n    word-wrap: break-word;\n    overflow-wrap: break-word;\n    background-color: #d3d3d3;\n    color: #333;\n    font-weight: 500;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
